import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BudgetAccountSettingsModal = ({
  isOpen,
  retailer,
  retailerConfig,
  onCancel,
}) => {
  const theme = useSelector(store => store.theme);

  const modalClasses = classNames({
    'modal-dialog--primary': true,
  }, theme.className, 'ltr-support');

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      className={modalClasses}
    >
      <ModalHeader>
        <h3>Budget Account Settings Required</h3>
        <p className="typography-message">
          Please configure your budget account settings for <strong>{retailerConfig?.name || retailer}</strong> before continuing.
        </p>
      </ModalHeader>
      <ModalBody style={{ textAlign: 'center' }}>
        <p className="typography-message">
          Please go to the <strong>Account tab</strong> to review and approve the required settings.
        </p>
        <br />
        <Button color="primary" onClick={onCancel} block>
          Go to Account Tab
        </Button>
      </ModalBody>
    </Modal>
  );
};

BudgetAccountSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  retailer: PropTypes.string.isRequired,
  retailerConfig: PropTypes.shape({
    name: PropTypes.string,
  }),
  onCancel: PropTypes.func.isRequired,
};

BudgetAccountSettingsModal.defaultProps = {
  retailerConfig: {},
};

export default BudgetAccountSettingsModal;
